export default class UpdatePublicHolidayRequest {
    name: string = '';
    holidayDate: Date = new Date();
    regionId: string = '';
}